


































import { Component, Vue, Watch } from "vue-property-decorator";
import { app } from "@/models/Application";
import { UserType } from "@/services/LoginService";
@Component({})
export default class extends Vue {
    private username: string = "";
    private password: string = "";
    private errorMessage: string = "";

    @Watch("username")
    public onUserNameChange() {
        this.errorMessage = "";
    }

    @Watch("password")
    public onPasswordChange() {
        this.errorMessage = "";
    }

    public checkKey(e: any) {
        if (e.keyCode === 13) {
        this.login();
        }
    }

    public login() {
        app.loginService
            .login(this.username, this.password)
            .then((result: any) => {
                app.pushNotificationService
                    .registerToken()
                    .then(response => {
                        console.log(response);
                    })
                    .catch(e => {
                        console.log(e);
                    });

                if (result.user_type) {
                    if (result.user_type === UserType.SuperAdministrator) {
                        this.$router.push({ name: "superadmin_home" });
                    } else if (result.user_type === UserType.Administrator) {
                        this.$router.push({ name: "admin_home" });
                    } else if (result.user_type === UserType.Waiter) {
                        this.$router.push({ name: "waiter_home" });
                    } else if (result.user_type === UserType.Cook) {
                        this.$router.push({ name: "cook_home" });
                    } else if (result.user_type === UserType.Bartender) {
                        this.$router.push({ name: "bartender_home" });
                    } else if (result.user_type === UserType.Driver) {
                        this.$router.push({ name: "driver_home" });
                    }
                }
            })
            .catch(error => {
                if ("errorMessage" in error) {
                    this.errorMessage = error.errorMessage;
                } else {
                    this.errorMessage = "";
                }
            });
    }
}
